import React from 'react';
import store from '../store';
import {logoutApp} from 'store/global/actions';
import {Button, Modal} from 'antd';

export const TIMEOUT = 5;
export const UPGRADE_PLAN_FORM_LINK = '/insightsdirect/register';
export const TELEGRAM_BRANDING_QR_LINK = 'https://t.me/dbsinsightsdirect';
export const EQUITY_FACTORS = 'equityFactors';
export const CREDIT_FACTORS = 'creditFactors';
export const CLOVERS_FACTORS = 'cloversFactors';
export const WATCHLIST_KEYS = {
    company: 'MyPortfolio',
    industry: 'MyPortfolioIndustry',
    country: 'MyPortfolioCountry',
    credit: 'MyPortfolioCredit',
    // rate: 'MyPortfolioRate',
    // currency: 'MyPortfolioCurrency',
};
export const ENTITY_ID_KEYS = {
    company: 'ric',
    industry: 'indId',
    country: 'countryId',
    credit: 'csId',
};
export const DEFAULT_TITLE = 'DBS Research Insights Direct';
//DropDowns for company columns
const dd1 = [
    {key: 'sharePriceYtd', label: 'Share Price YTD'},
    {key: 'fwdDividendYield', label: 'Dividend Yield'},
    {key: 'sharePrice', label: 'Share Price'},
    {key: 'roe', label: 'ROE'},
    {key: 'fwdEPS', label: 'EPS'},
    {key: 'fwdPE', label: 'Current PE'},
    {key: 'fwdPB', label: 'Current PB'},
    {key: 'dbsTarget', label: 'Target Price'},
    {key: 'potentialReturn', label: 'Potential Return'},
];

const dd2 = [
    {key: 'potentialReturn', label: 'Potential Return'},
    {key: 'dbsTarget', label: 'Target Price'},
    {key: 'roe', label: 'ROE'},
    {key: 'sharePrice', label: 'Share Price'},
    {key: 'fwdEPS', label: 'EPS'},
    {key: 'fwdPE', label: 'Current PE'},
    {key: 'fwdPB', label: 'Current PB'},
    {key: 'fwdDividendYield', label: 'Dividend Yield'},
    {key: 'sharePriceYtd', label: 'Share Price YTD'},
];

const dd3 = [
    {key: 'marketCapUSD', label: 'Market Cap'},
    {key: 'netProfit', label: 'Net Profit'},
    {key: 'volume', label: 'Volume Traded'},
];
export const COLUMNS = {
    company: [
        {label: 'Name', key: 'name', canChangeKey: false, width: '20%'},
        {label: 'Sector', key: 'sector', canChangeKey: false, width: '12%'},
        {label: 'Call', key: 'dbsRcmd', canChangeKey: false, width: '8%'},
        {
            label: 'Share Price',
            key: 'X-AXIS',
            canChangeKey: true,
            dd: dd1,
            width: '15%',
        },
        {
            label: 'Target Price',
            key: 'Y-AXIS',
            canChangeKey: true,
            dd: dd2,
            width: '15%',
        },
        {
            label: 'Market Cap',
            key: 'Size',
            canChangeKey: true,
            dd: dd3,
            width: '15%',
        },
        {label: 'Update Date', key: 'date', canChangeKey: false, width: '9%'},
        {label: 'AddAllWatchList', key: '', canChangeKey: false, width: '6%'},
    ],
    industryPageCompany: [
        {label: 'Name', key: 'name', canChangeKey: false, width: '16%'},
        {label: 'Sector', key: 'sector', canChangeKey: false, width: '13%'},
        {label: 'Call', key: 'dbsRcmd', canChangeKey: false, width: '8%'},
        {
            label: 'Share Price',
            key: 'sharePrice',
            canChangeKey: true,
            dd: dd1,
            width: '14%',
        },
        {
            label: 'Target Price',
            key: 'dbsTarget',
            canChangeKey: true,
            dd: dd2,
            width: '15%',
        },
        {
            label: 'Market Cap',
            key: 'marketCapUSD',
            canChangeKey: true,
            dd: dd3,
            width: '15%',
        },
        {
            label: 'Update Date',
            key: 'lastUpdateDate',
            canChangeKey: false,
            width: '10%',
        },
        {label: 'AddAllWatchList', key: '', canChangeKey: false, width: '9%'},
    ],
    industry: [
        {label: 'Name', key: 'name', canChangeKey: false, width: '24%'},
        {label: 'Sector', key: 'sectorList', canChangeKey: false, width: '15%'},
        {
            label: 'No. of companies',
            key: 'companyCount',
            canChangeKey: false,
            width: '20%',
        },
        {
            label: 'Country',
            key: 'locationName',
            canChangeKey: false,
            width: '20%',
        },
        {
            label: 'Update Date',
            key: 'lastUpdateDate',
            canChangeKey: false,
            width: '15%',
        },
        {label: 'AddAllWatchList', key: '', canChangeKey: false, width: '6%'},
    ],
    country: [
        {label: 'Name', key: 'name', canChangeKey: false, width: '20%'},
        {label: 'Index', key: 'indexValue', canChangeKey: false, width: '14%'},
        {
            label: 'Exchange Rate',
            key: 'currValue',
            canChangeKey: false,
            width: '14%',
        },
        {
            label: 'GDP Growth',
            key: 'gdpValue',
            canChangeKey: false,
            width: '14%',
        },
        {
            label: 'Interest Rate',
            key: 'rateValue',
            canChangeKey: false,
            width: '14%',
        },
        {
            label: 'Update Date',
            key: 'lastUpdateDate',
            canChangeKey: false,
            width: '14%',
        },
        {label: 'AddAllWatchList', key: '', canChangeKey: false, width: '10%'},
    ],
};

export const WATCHLIST_COMPANY_COLUMNS = [
    {label: 'Name', key: 'name', canChangeKey: false, width: '20%'},
    {label: 'Sector', key: 'sector', canChangeKey: false, width: '16%'},
    {label: 'Call', key: 'dbsRcmd', canChangeKey: false, width: '8%'},
    {
        label: 'Share Price',
        key: 'X-AXIS',
        canChangeKey: true,
        dd: dd1,
        width: '15%',
    },
    {
        label: 'Target Price',
        key: 'Y-AXIS',
        canChangeKey: true,
        dd: dd2,
        width: '16%',
    },
    {
        label: 'Market Cap',
        key: 'Size',
        canChangeKey: true,
        dd: dd3,
        width: '16%',
    },
    {label: 'Update Date', key: 'date', canChangeKey: false, width: '9%'},
    {label: 'AddAllWatchList', key: '', canChangeKey: false, width: '6%'},
];
export const EMAIL_NOTIFS_FREQUENCY_OPTIONS = [
    {
        label: 'Daily',
        value: 'daily',
    },
    {
        label: 'Weekly',
        value: 'weekly',
    },
    {
        label: 'Live (Default)',
        value: 'live',
    },
];
export const PAGE_SEC = {
    ANALYST_CHAT: 'analystChat',
    WHATSNEW: 'whatsnew',
};
export const MODALS = {
    NEWS_LETTER: 'NEWS_LETTER',
    DISCLAIMER: 'DISCLAIMER',
    PRO_MINUS: 'PRO_MINUS',
    PRO_MINUS_PWD: 'PRO_MINUS_PWD',
    SET_PASSWORD: 'SET_PASSWORD',
    PASSWORD_REMAINDER: 'PASSWORD_REMAINDER',
    CHANGE_PASSWORD: 'CHANGE_PASSWORD',
    RESET_PASSWORD: 'RESET_PASSWORD',
};
export const DropDownSections = [
    {
        id: -1,
        listName: 'Thematic',
        title: 'Thematic Ideas',
        valueStr: 'selectedFirstDDIndex',
        entityId: 'thematic',
    },
    {
        id: -2,
        listName: 'IndustryIdeas',
        title: 'Industry Ideas',
        valueStr: 'selectedIndustryDDIndex',
        entityId: 'Industryideas',
    },
    {
        id: -3,
        listName: 'EquityPicks',
        title: 'Equity Picks',
        valueStr: 'selectedEquityDDIndex',
        entityId: 'Equity picks',
    },
    {
        id: -999,
        listName: 'MacroIdeas',
        title: 'Macro Ideas',
        valueStr: 'selectedMacroDDIndex',
        entityId: 'Macro Ideas',
    },
];
export const FREE_ACCESS_ERROR = () => {
    return (
        <div style={{fontSize: 16}}>
            {/* To access more research content, you are required to have a premium
            or above access. Kindly proceed to <b>login</b> if you are already
            an existing premium user or contact us at{' '}
            <a
                href={`mailto:subscribe_dbsid@dbs.com`}
                style={{
                    cursor: 'pointer',
                }}
                target="_blank"
                rel="noopener noreferrer"
            >
                subscribe_dbsid@dbs.com
            </a>{' '} */}
            {/* for enquiries on upgrading. */}
            To access non-Singapore company information, you are required to{' '}
            <b>register</b> or kindly proceed to <b>login</b> if you are already
            an existing user
            <div className="flex align-center mt-10">
                <Button
                    style={{
                        color: '#19ba62',
                        border: '1px solid #19ba62',
                        textTransform: 'uppercase',
                        fontWeight: 'bold',
                    }}
                    onClick={() =>
                        window.open(UPGRADE_PLAN_FORM_LINK, '_blank')
                    }
                >
                    Register
                </Button>
                <Button
                    style={{
                        marginLeft: 10,
                        color: '#19ba62',
                        border: '1px solid #19ba62',
                        textTransform: 'uppercase',
                        fontWeight: 'bold',
                    }}
                    onClick={() => {
                        store.dispatch(logoutApp());
                        Modal.destroyAll();
                    }}
                >
                    Login
                </Button>
            </div>
        </div>
    );
};
export const REGISTER_TO_ACCESS = () => {
    return (
        <div style={{fontSize: 16}}>
            To access more research content, you are required to <b>register</b>{' '}
            or kindly proceed to <b>login</b> if you are already an existing
            user.
            <div className="flex align-center mt-10">
                <Button
                    style={{
                        color: '#19ba62',
                        border: '1px solid #19ba62',
                        textTransform: 'uppercase',
                        fontWeight: 'bold',
                    }}
                    onClick={() =>
                        window.open(UPGRADE_PLAN_FORM_LINK, '_blank')
                    }
                >
                    Register
                </Button>
                <Button
                    style={{
                        marginLeft: 10,
                        color: '#19ba62',
                        border: '1px solid #19ba62',
                        textTransform: 'uppercase',
                        fontWeight: 'bold',
                    }}
                    onClick={() => {
                        store.dispatch(logoutApp());
                        Modal.destroyAll();
                    }}
                >
                    Login
                </Button>
            </div>
        </div>
    );
};
export const UPGRADE_TO_ACCESS = () => {
    return (
        // <div style={{fontSize: 16}}>
        //     The download report function is only available for DBS clients. If
        //     you are an existing DBS client. please inform our customer service
        //     to Upgrade your plan
        //     <div className="flex align-center mt-10">
        //         <a
        //             href="mailto:subscribe_dbsid@dbs.com"
        //             style={{
        //                 color: '#19ba62',
        //                 border: '1px solid #19ba62',
        //                 textTransform: 'uppercase',
        //                 fontWeight: 'bold',
        //                 fontSize: 14,
        //                 padding: '5px 10px',
        //                 borderRadius: 4,
        //             }}
        //         >
        //             Upgrade
        //         </a>
        //     </div>
        // </div>
        <REGISTER_TO_ACCESS />
    );
};

export const PASSWORD_HINT = () => {
    return (
        <>
            Password must be at least 8 characters in length.
            <br />
            Password must include at least 1 uppercase character and 1 number.
            <br />
            Password must include at least one of the following special
            characters !@#$%^&*()_+&lt;&gt;?
            <br />
            Password cannot be the same as email.
            <br />
            Password cannot have 3 or more consecutive same characters.
            <br />
        </>
    );
};
